export default () => {
    const product = document.querySelector('.product')
    const productBlock = document.querySelector('.products-related')

    // if (product) {
    //     const products = $('.product')

    //     products.each(function () {
    //        const availability = $(this).find('.availability-amount')

    //         if (availability.length === 0) {
    //             $(this).find('.price-final').addClass('no-availability')
    //             $(this).find('.price-final').text('Vyprodáno')
    //         }
    //     });
    // }

    if (productBlock) {
        $('.products-related-header').text('Doporučené produkty')
    }


}